/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondToAuthChallengeRequest
 */
export interface RespondToAuthChallengeRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof RespondToAuthChallengeRequest
     */
    readonly $schema?: string;
    /**
     * Challenge responses
     * @type {{ [key: string]: string; }}
     * @memberof RespondToAuthChallengeRequest
     */
    challengeResponses: { [key: string]: string; };
    /**
     * Challenge type
     * @type {string}
     * @memberof RespondToAuthChallengeRequest
     */
    challengeType: string;
    /**
     * Session
     * @type {string}
     * @memberof RespondToAuthChallengeRequest
     */
    session: string;
    /**
     * Username
     * @type {string}
     * @memberof RespondToAuthChallengeRequest
     */
    username: string;
}

/**
 * Check if a given object implements the RespondToAuthChallengeRequest interface.
 */
export function instanceOfRespondToAuthChallengeRequest(value: object): value is RespondToAuthChallengeRequest {
    if (!('challengeResponses' in value) || value['challengeResponses'] === undefined) return false;
    if (!('challengeType' in value) || value['challengeType'] === undefined) return false;
    if (!('session' in value) || value['session'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function RespondToAuthChallengeRequestFromJSON(json: any): RespondToAuthChallengeRequest {
    return RespondToAuthChallengeRequestFromJSONTyped(json, false);
}

export function RespondToAuthChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToAuthChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'challengeResponses': json['challenge_responses'],
        'challengeType': json['challenge_type'],
        'session': json['session'],
        'username': json['username'],
    };
}

export function RespondToAuthChallengeRequestToJSON(json: any): RespondToAuthChallengeRequest {
    return RespondToAuthChallengeRequestToJSONTyped(json, false);
}

export function RespondToAuthChallengeRequestToJSONTyped(value?: Omit<RespondToAuthChallengeRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_responses': value['challengeResponses'],
        'challenge_type': value['challengeType'],
        'session': value['session'],
        'username': value['username'],
    };
}

